import $ from 'jquery'

$(document).ready(function() {
	$('.menu-toggle').click(function() {
		$(this).toggleClass('is-active')
		$(
			'#site-navigation ,.mobile-menu-bg, #page, .site-branding, #site-header-side, .site-header-form'
		).toggleClass('is-active')
	})

	$('#menu-primary > .menu-item-has-children').click(function() {
		$(this)
			.siblings()
			.removeClass('is-active')
		$(this).toggleClass('is-active')
	})
})
